module.exports = __webpack_public_path__ + "img/image_background.af870a78.webp";